<app-menu/>

<div class="row column mobile-version">
  <a routerLink="/account" class="alert">Продовжити покупки</a>
</div>

<div class="password-changed" *ngIf="successfullySaved">
  <h2>Данні збережено</h2>
</div>

<div class="page-container">
  <div class="content">
    <div class="row" *ngIf="data && !successfullySaved">
      <div class="column">
        <div class="row column">
          <h2>Налаштування облікового запису</h2>
        </div>

        <div class="row">
          <div class="column">
            <h3>Особиста інформація</h3>
          </div>
        </div>
        <div class="column items-center">
          <div class="shrink text-right show-for-large">
            <p>ПІБ</p>
          </div>
          <div [class.border-wrong]="wrongFio">
            <input type="text" name="fio" [(ngModel)]="data.fio" class="input-text">
            <span class="status" [class.status-error]="wrongFio">Введіть своє ім'я та прізвище</span>
          </div>
        </div>

        <div class="column items-center">
          <div class="shrink text-right show-for-large">
            <p>Email</p>
          </div>
          <div>
            <input type="text" name="email" disabled [(ngModel)]="data.email" class="input-text">
          </div>
        </div>

        <div class="column items-center">
          <div class="shrink text-right show-for-large">
            <p>Телефон</p>
          </div>
          <div [class.border-wrong]="wrongPhone">
            <input type="text"
                   name="phone"
                   #phoneRef
                   appPhoneMask
                   [(ngModel)]="data.phone"
                   class="input-text">
            <span class="status" [class.status-error]="wrongPhone">Введіть номер мобільного телефону</span>
          </div>
        </div>

        <div class="column items-center">
          <div class="shrink text-right show-for-large">
            <p>Місто</p>
          </div>
          <div class="city-container" [class.border-wrong]="wrongCity">
            <input [(ngModel)]="data.city_id" type="hidden" name="city_id">
            <input [(ngModel)]="data.area_id" type="hidden" name="area_id">
            <input type="text"
                   autocomplete="off"
                   (input)="searchCity()"
                   [(ngModel)]="data.city"
                   class="input-text"
            >
            <span class="status" [class.status-error]="wrongCity">Виберіть Ваше місто</span>
            <ng-container *ngIf="addressData.length > 0">
              <div class="np-search-results">
                <ul>
                  <li>
                    <a *ngFor="let address of addressData; let i = index" (click)="getCity(i)">
                      {{ address.description }}
                    </a>
                  </li>
                </ul>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="row">
          <div class="column">
            <button class="button float-right" (click)="saveInfo()">
              Зберегти
            </button>
          </div>
        </div>

        <ng-container *ngIf="buEnabled || buStuck">
          <div class="row vertical-line">
            <div class="column">
              <hr>
            </div>
          </div>

          <div class="row">
            <div class="column">
              <h3>Організації</h3>
            </div>
          </div>

          <div class="organizations-table-wrapper">
            <table class="organizations-table">
              <thead>
              <tr>
                <th>Найменування організації</th>
                <th>Форма власності</th>
                <th>ЄДРПОУ</th>
                <th>Статус</th>
                <th>Дії</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let organization of organizations" [class.fiz]="organization.type === 'fiz'">
                <td>
                  <span class="mobile-label">Найменування організації</span>
                  {{ organization.name }}
                </td>

                <td>
                  <span class="mobile-label">Форма власності</span>
                  {{ organization.type === 'fop' ? 'ФОП' : organization.type === 'tov' ? 'ТОВ' : '' }}
                </td>

                <td>
                  <span class="mobile-label">ЄДРПОУ</span>
                  {{ organization.edrpou }}
                </td>

                <td>
                  <span class="mobile-label">Статус</span>

                  <span *ngIf="organization.is_active === '1' || organization.is_active === true" class="active-label">Активна</span>

                  <button
                    *ngIf="organization.is_active !== '1' && organization.is_active !== true && (buEnabled || organization.type === 'fiz')"
                    type="button"
                    class="button small-button"
                    (click)="setActiveOrganization(organization)">
                    Активувати
                  </button>
                </td>

                <td>
                  <span class="mobile-label">Дії</span>

                  <button
                    *ngIf="organization.type !== 'fiz'"
                    type="button"
                    class="button small-button"
                    (click)="deleteOrganization(organization)">
                    Видалити
                  </button>
                </td>
              </tr>
              </tbody>
            </table>

            <div class="organization-error" *ngIf="organizationError">
              {{ organizationError }}
            </div>
          </div>

          <div class="row" *ngIf="buEnabled">
            <div class="column">
              <button class="button float-right" (click)="addOrganization()">Додати організацію</button>
            </div>
          </div>

          <div class="row vertical-line">
            <div class="column">
              <hr>
            </div>
          </div>
        </ng-container>

        <div class="row">
          <div class="column">
            <h3>Змінити пароль</h3>
          </div>
        </div>
        <div class="column items-center">
          <div class="shrink text-right show-for-large">
            <p>Введіть поточний пароль</p>
          </div>
          <div [class.border-wrong]="wrongPassword.length > 0">
            <input [type]='isPasswordShow ? "text" : "password"'
                   name="password"
                   class="input-text"
                   autocomplete="off"
                   [(ngModel)]="password"
            >
            <span class="password-eye" *ngIf="!isPasswordShow" (click)="clickShowPassword()"></span>
            <span class="password-eye-hide" *ngIf="isPasswordShow" (click)="clickHidePassword()"></span>
            <span class="status" [class.status-error]="wrongPassword.length > 0">{{ wrongPassword }}</span>
          </div>
        </div>

        <div class="column items-center">
          <div class="shrink text-right show-for-large">
            <p>Введіть новий пароль</p>
          </div>
          <div>
            <input type="text" [(ngModel)]="newPassword" class="input-text">
          </div>
        </div>

        <div class="column items-center">
          <div class="shrink text-right show-for-large">
            <p>Повторіть новий пароль</p>
          </div>
          <div>
            <div [class.border-wrong]="wrongPassword2.length > 0">
              <input type="text" [(ngModel)]="newPassword2" class="input-text">
              <span class="status" [class.status-error]="wrongPassword2.length > 0">{{ wrongPassword2 }}</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="column">
            <button class="button float-right" (click)="saveNewPassword()">Зберегти</button>
          </div>
        </div>

        <div class="row">
          <div class="column">
            <hr>
          </div>
        </div>

        <div class="row">
          <div class="column">
            <h3>Налаштування розсилки прайс-листа</h3>
          </div>
        </div>
        <div class="row items-center">
          <div class="column">
            <label class="label-checkbox-reverse"
                   [class.active]="data.price_our"
                   (click)="sendPriceToEmailCheckbox()">Прайс наш склад</label>
          </div>
        </div>
        <div class="row items-center">
          <div class="column">
            <label class="label-checkbox-reverse"
                   [class.active]="data.price_partner_oils"
                   (click)="partnerPriceCheckbox('price_partner_oils')">Прайс партнерський Масла</label>
            <input type="checkbox">
          </div>
        </div>
        <div class="row items-center">
          <div class="column">
            <label class="label-checkbox-reverse"
                   [class.active]="data.price_partner_filters"
                   (click)="partnerPriceCheckbox('price_partner_filters')">Прайс партнерський Фільтра</label>
            <input type="checkbox">
          </div>
        </div>
        <div class="row items-center">
          <div class="column">
            <label class="label-checkbox-reverse"
                   [class.active]="data.price_partner_parts"
                   (click)="partnerPriceCheckbox('price_partner_parts')">Прайс партнерський Запчастини</label>
            <input type="checkbox">
          </div>
        </div>

        <div class="column items-center">
          <div class="shrink text-right show-for-large">
            <p>Вибір валюти</p>
          </div>
          <div>
            <select class="input-text" [(ngModel)]="data.price_currency_id">
              <option *ngFor="let currency of currencies" [value]="currency.id">
                {{ currency.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="column items-center">
          <div class="shrink text-right show-for-large">
            <p>E-mail</p>
          </div>
          <div>
            <input type="text" [(ngModel)]="data.email_for_price" class="input-text">
            <span class="status" [class.status-error]="wrongEmail">Некорректна адреса електронної пошти.</span>
          </div>
        </div>

        <div class="row items-center">
          <div class="column">
            <label class="label-checkbox-reverse"
                   [class.active]="data.price_not_available"
                   (click)="priceContainsExpectedPositionCheckbox()">Прайс містить очікувані позиції</label>
          </div>
        </div>
        <div class="row items-center">
          <div class="column">
            <label class="label-checkbox-reverse"
                   [class.active]="data.price_all_articles"
                   (click)="priceAllArticlesCheckbox()">Розширені артикули товарів</label>
            <input type="checkbox">
          </div>
        </div>

        <div class="row">
          <div class="column">
            <button class="button float-right" (click)="sendPricePartners()">Зберегти</button>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <hr>
          </div>
        </div>

        <div class="row margin-text">
          <div class="column">
            <h3>Налаштування повідомлень</h3>
          </div>
        </div>
        <div class="row items-center">
          <div class="column shrink">
            <p>Підпишіться на наш бот</p>
            <a href="https://telegram.me/maslotochkacombot" class="alert" target="_blank">
              @maslotochkacombot
            </a>
          </div>
          <div class="column shrink">
            <button class="button" (click)="showInstructions()">Інструкція</button>
          </div>
          <div class="column"></div>
        </div>

        <div class="row messages-text">
          <div class="column">
            <b>Включені повідомлення:</b>
          </div>
        </div>
        <div class="notifies-settings">
          <div class="row items-center">
            <div class="column box-color-orange">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_notify_order_date_changed"
                     (click)="switchCheckbox('no_notify_order_date_changed')"
              >
                зміна дати в замовленні;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-orange">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_email_notify_arrival_zgoods"
                     (click)="switchCheckbox('no_email_notify_arrival_zgoods')"
              >
                на пошту про прибуття підзаказних товарів;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-orange">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_email_notify_made_order"
                     (click)="switchCheckbox('no_email_notify_made_order')"
              >
                на пошту про замовлення;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-orange">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_email_notify_order_changed"
                     (click)="switchCheckbox('no_email_notify_order_changed')"
              >
                на пошту про зміни в замовленні;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-orange">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_email_notify_order_date_changed"
                     (click)="switchCheckbox('no_email_notify_order_date_changed')"
              >
                на пошту про зміну дати доставки замовлення;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-orange">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_email_notify_order_from_admin"
                     (click)="switchCheckbox('no_email_notify_order_from_admin')"
              >
                на пошту до замовлення від адміністрації сайту;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-green">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_window_notify_arrival_favorites"
                     (click)="switchCheckbox('no_window_notify_arrival_favorites')"
              >
                в вікно повідомлень про прибуття товарів, доданих до списку побажань;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-green">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_window_notify_arrival_zgoods"
                     (click)="switchCheckbox('no_window_notify_arrival_zgoods')"
              >
                в вікно повідомлень про прибуття підзаказних товарів;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-green">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_window_notify_order_changed"
                     (click)="switchCheckbox('no_window_notify_order_changed')"
              >
                в вікно повідомлень про зміни в замовленні;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-green">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_window_notify_order_date_changed"
                     (click)="switchCheckbox('no_window_notify_order_date_changed')"
              >
                в вікно повідомлень про зміну дати доставки замовлення;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-green">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_window_notify_order_from_admin"
                     (click)="switchCheckbox('no_window_notify_order_from_admin')"
              >
                в вікно повідомлень до замовлення від адміністрації сайту;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-violet">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_telega_notify_arrival_favorites"
                     (click)="switchCheckbox('no_telega_notify_arrival_favorites')"
              >
                в телеграм про прибуття товарів, доданих до списку побажань;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-violet">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_telega_notify_arrival_zgoods"
                     (click)="switchCheckbox('no_telega_notify_arrival_zgoods')"
              >
                в телеграм про прибуття підзаказних товарів;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-violet">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_telega_notify_order_changed"
                     (click)="switchCheckbox('no_telega_notify_order_changed')"
              >
                в телеграм про зміни в замовленні;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-violet">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_telega_notify_order_date_changed"
                     (click)="switchCheckbox('no_telega_notify_order_date_changed')"
              >
                в телеграм про зміну дати доставки замовлення;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-violet">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_telega_notify_order_driver"
                     (click)="switchCheckbox('no_telega_notify_order_driver')"
              >
                в телеграм про контакти водія доставки замовлення;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-violet">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_telega_notify_order_ttn"
                     (click)="switchCheckbox('no_telega_notify_order_ttn')"
              >
                в телеграм про створення ТТН до замовлення;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-violet">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_telega_notify_order_goodsarrive"
                     (click)="switchCheckbox('no_telega_notify_order_goodsarrive')"
              >
                в телеграм про прибуття на склад товарів замовлення;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-violet">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_telega_notify_payment"
                     (click)="switchCheckbox('no_telega_notify_payment')"
              >
                в телеграм про проведення оплати;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-violet">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_telega_notify_change_currencyrate"
                     (click)="switchCheckbox('no_telega_notify_change_currencyrate')"
              >
                в телеграм про зміну курса;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-violet">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_telega_notify_change_statusorder"
                     (click)="switchCheckbox('no_telega_notify_change_statusorder')"
              >
                в телеграм про зміну статуса замовлення;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-violet">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_telega_notify_return_requests"
                     (click)="switchCheckbox('no_telega_notify_return_requests')"
              >
                в телеграм про заявки на повернення;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-violet">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_telega_notify_places_for_dropship"
                     (click)="switchCheckbox('no_telega_notify_places_for_dropship')"
              >
                в телеграм про кількість місць до служби дропшип;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-violet">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_telega_notify_pay_delivery"
                     (click)="switchCheckbox('no_telega_notify_pay_delivery')"
              >
                в телеграм про оплату пересилки;
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-violet">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_telega_notify_goods_change_warehouse"
                     (click)="switchCheckbox('no_telega_notify_goods_change_warehouse')"
              >
                В телеграм про переміщення між складами
              </label>
            </div>
          </div>

          <div class="row items-center">
            <div class="column box-color-violet">
              <label class="label-checkbox-reverse"
                     [class.active]="data.no_telega_notify_nova_poshta_arrived"
                     (click)="switchCheckbox('no_telega_notify_nova_poshta_arrived')"
              >
                В телеграм про прибуття замовлення на Нову Пошту
              </label>
            </div>
          </div>

          <div class="row">
            <div class="column">
              <button class="button float-right" (click)="saveEmailSettings()">Зберегти</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-goods mobile-version">
    <footer>
      <small>© 2010-{{ currentYear }}. Всі права захищені.</small>
    </footer>
  </div>
</div>

<div class="modals instructions" [class.modals-show]="isModalInstructionsShow"
     [class.modals-hide]="!isModalInstructionsShow">
  <a class="close-modal" (click)="closeModal()"></a>

  <h4>Інструкція для бота «як користуватись ботом»</h4>

  <p>1. В додатку Телеграм додаєте у наш Бот @MaslotochkacomBot свій логін (email пошту, яку використовуєте на сайті
    Maslotochka, можливо переглянути в меню, налаштування акаунту)
    та відправляєте, потім відправляєте Ваш пароль (можливо самостійно відновити або звернутися до адміністратора
    сайту).</p>

  <p>2. При необхідності, фукцію повідомлень від Maslotochka можливо самостійно налаштувати
    (включити або відключити відповідні теми) для цього заходимо в меню - налаштування акаунту - налаштування
    повідомлень та обираємо необхідне. Після натискаємо кнопку «зберегти».</p>

  <p>3. Для того, щоб відписатись від @MaslotochkacomBot, в меню @MaslotochkacomBot натискаємо кнопку зупинити бота.</p>
</div>

<app-modal-organization [organization]="newOrganization" (saveOrganizationData)="createOrganization($event)"></app-modal-organization>

<div class="dark-layer" [class.modals-show]="isModalInstructionsShow" (click)="closeModal()"></div>
